import React from "react";
import { Container, Row} from "shards-react";
import PageTitle from "./../components/common/PageTitle";
import { useAuth } from '../contexts/AuthContext';
import useFirestore from '../hooks/useFirestore';
import FileTable from "../components/components-overview/FileTable";
import SkeletonArticle from "../components/skeleton/SkeletonArticle";

const PastReports = () => {
  const { currentUser } = useAuth();
  const {isLoading, docs } =  useFirestore('reports');
  
  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle title="Past Reports" subtitle={currentUser.username ? currentUser.username : 'Your Company'} className="text-sm-left mb-3" />
      </Row> 

      {isLoading && <SkeletonArticle />}

      {/* If loading is false, render filetable*/}
      {!isLoading &&<FileTable docs={docs}/>}


      {/* Page Header */}

    </Container>
  );
}
export default PastReports;